import React from 'react'
import { JourneyStep } from 'src/lib/hooks/useNavigation'
import { JourneyNavigationComponent } from '../../components/navigation/SecondaryNavBars/common/NavigationWrapper'

interface SecondaryNavigationBarProps {
  journeyStep: JourneyStep
}

const SecondaryNavigationBar = ({ journeyStep }: SecondaryNavigationBarProps) => {
  return (
    <nav
      className='flex max-h-full min-h-0 w-full flex-col overflow-hidden rounded-xl border-1 border-black/6 bg-gray-100'
      id='secondary-navigation-bar'
    >
      <JourneyNavigationComponent stepId={journeyStep} />
    </nav>
  )
}

export default SecondaryNavigationBar
